import React, { useState } from 'react';
import {
    Form, Row, Col,
} from 'antd';
import {FormFieldsWrapper} from "./styles";
import translations from "../../../screens/Search/translations";
import StyledDatePicker from "../../CustomAntdComponents/StyledDatePickerB2C/DatePicker";
import {getDisabledDateRange, getStartOfDay} from "../../../utils/helpers";
import {useI18nContext} from "../../../utils/I18n";
import {RangePickerProps} from "antd/es/date-picker";
import {RoadSearchStore} from "../../../store/roadSearch/types";
import {tripModes} from "../../../screens/Search/constant";
import StyledRadioGroup from "../../CustomAntdComponents/StyledRadioGroup";
import styled from "styled-components";
import {DepartureWrapper, SwitcherWrapper} from "../../FlightSearch/styles";
import {ReactComponent as DirectionIcon} from "../../../assets/images/direction.svg";
import ModifyRouteSelector from "../Flight/MobileRouteModifySelector";
import { DateRange } from 'react-day-picker';

type SearchProps = {
    onSubmit: () => void;
    payload: RoadSearchStore;
    onChange: (arg) => void;
    form: any;
}

const SearchMobile = ({ onSubmit, onChange, payload, form  }: SearchProps) => {
    const {
        state: { t },
    } = useI18nContext();
    const [selectedRange, setSelectedRange] = useState<DateRange | undefined>();

    const {
        TripType, DepartureId, ArrivalId, DepartureDate, ArrivalDate,
    } = payload
    const tripTypeWatch = Form.useWatch('TripType', form);
    const departureDateWatch = Form.useWatch('DepartureDate', form);
    const departureWatch = Form.useWatch('DepartureId', form);
    const arrivalWatch = Form.useWatch('ArrivalId', form);
    const isRoundTrip = tripTypeWatch === 'round_trip';
    const formInitialValues = {
        TripType, DepartureId, ArrivalId, DepartureDate, ArrivalDate,
        DateRange: [DepartureDate, ArrivalDate]
    };

    const validateDestination = (_: any, value: any) => {
        if (!value) {
            return Promise.reject(new Error(t(translations).validations.destination));
        }

        if (form.getFieldValue('DepartureId') === value) {
            return Promise.reject(new Error(t(translations).validations.invalidDestination));
        }

        return Promise.resolve();
    };

    const checkReturningDate = (_: any, value: any) => {
        if(tripTypeWatch === 'one_way') return Promise.resolve();

        const departureDate = form.getFieldValue('DepartureDate');

        if (!value) {
            return Promise.reject(new Error(t(translations).validations.destinationDate));
        }

        if (value.isBefore(departureDate)) {
            return Promise.reject(new Error(t(translations).validations.invalidDestinationDate));
        }
        return Promise.resolve();
    };

    const onFormInputChange = (value: any, name: string) => {
        onChange({
            [name]: value,
        });
    };

    const disabledReturnDate: RangePickerProps['disabledDate'] = (current) => getDisabledDateRange(current, getStartOfDay(departureDateWatch));
    const onFinish = () => {
        onSubmit();
    };

    const handleSwitchTerminal = () => {
        onChange({
            DepartureId: arrivalWatch,
            ArrivalId: departureWatch,
        });

        form.setFieldsValue({
            DepartureId: arrivalWatch,
            ArrivalId: departureWatch,
        });
    }

    const flightModes = tripModes(t(translations));


    const getInitialDateRange = (): DateRange | undefined => {
        const originalInput = (DepartureDate as any)?._i;

        if (originalInput?.from) {
            return {
            from: new Date(originalInput.from),
            to: originalInput.to ? new Date(originalInput.to) : undefined,
            };
        }

        if ((DepartureDate as any)?.from) {
            return {
            from: new Date((DepartureDate as any).from),
            to: (DepartureDate as any).to
                ? new Date((DepartureDate as any).to)
                : undefined,
            };
        }

        if (DepartureDate) {
            return {
            from: new Date(DepartureDate as any),
            to: ArrivalDate ? new Date(ArrivalDate as any) : undefined,
            };
        }

        return undefined;
        };

        const initialDateRange = selectedRange ?? getInitialDateRange();

    return (
        <Form
            wrapperCol={{ span: 24 }}
            layout="horizontal"
            initialValues={formInitialValues}
            form={form}
            size="large"
            onFinish={onFinish}
        >
            <FormFieldsWrapper>
                <Row gutter={[8, 8]}>
                        <Col xs={24}>
                            {/* <Form.Item
                                name="TripType"
                                rules={[{ required: true, message: t(translations).validations.departure }]}
                            >
                                <StyledRadioGroup options={flightModes} value={TripType} onChange={(e) => onFormInputChange(e.target.value, 'TripType')} />
                            </Form.Item> */}
                        </Col>
                        <Col xs={24}>
                            <HeaderDepartureWrapper>
                                <Form.Item
                                    name="DepartureId"
                                    rules={[{ required: true, message: t(translations).validations.departure }]}
                                >
                                    <ModifyRouteSelector
                                        label={t(translations).inputs.from}
                                        value={DepartureId}
                                        onChange={(value) => onFormInputChange(value, 'DepartureId')}
                                        icon="circle"
                                    tripType="road"
                                    mode="from"
                                    />
                                </Form.Item>
                                <HeaderSwitcherWrapper onClick={handleSwitchTerminal}>
                                    <DirectionIcon />
                                </HeaderSwitcherWrapper>
                            </HeaderDepartureWrapper>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                name="ArrivalId"
                                rules={[
                                    {
                                        validator: validateDestination,
                                    },
                                ]}
                            >
                                <ModifyRouteSelector
                                    label={t(translations).inputs.to}
                                    value={DepartureId}
                                    onChange={(value) => onFormInputChange(value, 'ArrivalId')}
                                    icon="location"
                                tripType="road"
                                mode="to"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24}>
                            <Form.Item
                                name="DepartureDate"
                                rules={[{ required: true, message: t(translations).validations.departureDate }]}
                            >
                                <StyledDatePicker
                                    label={t(translations).inputs.departureDate}
                                    value={DepartureDate}
                                    returnValue={ArrivalDate}
                                    disabledDate={getDisabledDateRange}
                                    selectedRange={initialDateRange}
                                    setSelectedRange={(range: any) => {
                                        setSelectedRange(range);

                                        const data = {
                                        DepartureDate: range
                                            ? {
                                                from: range.from,
                                                to: range.to,
                                            }
                                            : undefined,
                                        ArrivalDate: range?.to,
                                        TripType: range?.to ? "round_trip" : "one_way",
                                        };

                                        onChange(data);
                                        form.setFieldsValue(data);
                                    }}
                                />
                            </Form.Item>
                        </Col>

                    
                </Row>
            </FormFieldsWrapper>
        </Form>
    );
};

const HeaderSwitcherWrapper = styled(SwitcherWrapper)`
    bottom: -25px;
`;

const HeaderDepartureWrapper = styled(DepartureWrapper)`
`;

export default SearchMobile;
